import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProtectedEmail from "@/components/ProtectedEmail";

export default function Impressum() {
  return (
    <main data-testid="impressum-page" className="min-h-screen bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="mt-8 font-display text-4xl sm:text-5xl tracking-tight">Impressum</h1>
        <p className="mt-2 text-sm text-zinc-500">Angaben gemäß § 5 TMG</p>

        <section className="mt-10 space-y-3 text-zinc-300 leading-relaxed text-base">
          <p className="font-medium text-white">Grayscale Media</p>
          <p>Lucas Grau</p>
          <p>
            Fichtestraße 27<br />
            99510 Apolda<br />
            Deutschland
          </p>
        </section>

        <section className="mt-8 space-y-3 text-zinc-400 text-sm">
          <h2 className="font-display text-lg text-white">Kontakt</h2>
          <p className="flex items-center gap-2">
            <span>E-Mail:</span>
            <ProtectedEmail
              variant="inline"
              testId="impressum-email"
              className="text-zinc-200 underline underline-offset-2 decoration-zinc-700 hover:decoration-white hover:text-white transition-colors"
            />
          </p>
        </section>

        <section className="mt-8 space-y-2 text-zinc-400 text-sm">
          <h2 className="font-display text-lg text-white">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </h2>
          <p>
            Lucas Grau<br />
            Fichtestraße 27<br />
            99510 Apolda
          </p>
        </section>

        <section className="mt-8 space-y-2 text-zinc-500 text-xs leading-relaxed">
          <h2 className="font-display text-lg text-white">Haftungsausschluss</h2>
          <p>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
            Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
            kann jedoch keine Gewähr übernommen werden. Externe Links wurden
            zum Zeitpunkt der Verlinkung auf rechtswidrige Inhalte geprüft;
            auf spätere Veränderungen haben wir keinen Einfluss.
          </p>
        </section>
      </div>
    </main>
  );
}
